<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faBullhorn} from '@fortawesome/free-solid-svg-icons';
export default {
    props: ['banner'],
    created() {
        library.add(faBullhorn);
    },
    methods: {
        openModal() {
            this.$emit('toggleBannerModal', true);
        },
        dismiss() {
            this.banner.show = "false";
            this.$emit('removeModal');
        },
    }
}
</script>
<template>
    <div class="bg-leonard-info" v-if="banner.show === 'true'">
        <div class="container mx-auto grid grid-cols-[auto_1fr_auto_auto] gap-x-1 sm:gap-x-4 lg:gap-x-6 items-center p-3 lg:p-4">
            <div class="w-10 h-10 place-content-center text-center rounded-md bg-leonard-info-overlay">
                <font-awesome-icon fixed-width :icon="['fas', 'bullhorn']" class="text-leonard-white" />
            </div>
            <p class="text-leonard-white truncate">
                    <span class="md:hidden">
                        {{ banner.short_text }}
                    </span>
                <span class="hidden md:inline">
                        {{ banner.long_text }}
                    </span>
            </p>
            <button type="button"
                    class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-transparent border-leonard-white text-leonard-white hover:bg-leonard-info-overlay hover:border-transparent focus:ring-leonard-info-overlay cursor-pointer"
                    @click.prevent="openModal">
                {{ banner.button_text }}
            </button>
            <button type="button"
                    class="p font-medium transition-all duration-300 border-2 rounded-md inline-block bg-transparent border-transparent text-leonard-white hover:text-leonard-white-hover cursor-pointer"
                    aria-label="Dismiss" @click.prevent="dismiss">
                <font-awesome-icon fixed-width :icon="['fas', 'xmark']" />
            </button>
        </div>
    </div>
</template>
